import NonNgwosSiteTooltip from "./Tooltip/NonNgwosSiteTooltip";
import NgwosTooltip from "./Tooltip/NgwosSiteTooltip";

const Tooltip = ({ tooltipInfo }) => {
  switch (tooltipInfo.layerId) {
    case "ngwos-project-sites":
      return <NgwosTooltip tooltipInfo={tooltipInfo} />;
    case "non-ngwos-project-sites":
      return <NonNgwosSiteTooltip tooltipInfo={tooltipInfo} />;
    default:
      return <NonNgwosSiteTooltip tooltipInfo={tooltipInfo} />;
  }
};

export default Tooltip;
